import { BulkActionsController } from "~/controllers/bulk_actions_controller"

export class Controller extends BulkActionsController {
  connect() {
    super.connect()
  }
}
